// extracted by mini-css-extract-plugin
export var sliderRange = "_ol-2";
export var sliderRoot = "_ol-0";
export var sliderThumb = "_ol-3";
export var sliderTrack = "_ol-1";